/* MedBound — riempie le stelline dei CARD prodotto (griglia home, "completa il bundle", ecc.)
   con i nostri dati reali, sostituendo i vecchi blocchi Junip.
   Mappa ogni .junip-product-summary al prodotto del suo card (link più vicino che precede).
   Resiliente: i card del tema possono comparire dopo il defer, quindi si ripete + osserva il DOM. */
(function () {
  var GOLD = "#FDB600";
  var MAP = {
    "anatomie":    { a: 4.89, n: 82 },
    "physiologie": { a: 4.92, n: 77 },
    "biochemie":   { a: 4.91, n: 74 },
    "biologie":    { a: 4.93, n: 67 },
    "bundle":      { a: 4.92, n: 332 }
  };
  var STAR = "m3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081z";
  function star(c) { return '<svg viewBox="0 0 16 16" width="16" height="16" style="display:inline-block;vertical-align:middle"><path d="' + STAR + '" fill="' + c + '"/></svg>'; }
  function ratingHTML(avg, n) {
    var pct = Math.max(0, Math.min(100, avg / 5 * 100));
    var base = "", fill = "";
    for (var i = 0; i < 5; i++) { base += star("#e4e4e7"); fill += star(GOLD); }
    return '<span style="position:relative;display:inline-flex;vertical-align:middle;line-height:0">' +
      '<span style="display:inline-flex">' + base + '</span>' +
      '<span style="position:absolute;top:0;left:0;display:inline-flex;overflow:hidden;white-space:nowrap;width:' + pct + '%">' + fill + '</span>' +
      '</span>' +
      '<span style="font-size:14px;color:#6b6b70;font-weight:600;margin-left:6px;vertical-align:middle;font-family:var(--font-body-family,Montserrat,sans-serif)">(' + n + ')</span>';
  }
  function keyFromHref(h) { if (!h) return null; for (var k in MAP) { if (h.indexOf(k) >= 0) return k; } return null; }

  function run() {
    var sums = [].slice.call(document.querySelectorAll('.junip-product-summary'));
    if (!sums.length) return 0;
    var links = [].slice.call(document.querySelectorAll('a[href]')).filter(function (a) { return keyFromHref(a.getAttribute("href")); });
    if (!links.length) return 0;
    var filled = 0;
    sums.forEach(function (s) {
      // idempotente per CONTENUTO: se il mio markup è già lì, salta (evita loop col MutationObserver).
      // se il tema ha ri-renderizzato il blocco (marker sparito), ri-riempi.
      if (s.querySelector("[data-mbok]")) return;
      var best = null;
      for (var j = 0; j < links.length; j++) {
        if (links[j].compareDocumentPosition(s) & Node.DOCUMENT_POSITION_FOLLOWING) best = links[j];
      }
      if (!best) return;
      var key = keyFromHref(best.getAttribute("href"));
      if (!key) return;
      var m = MAP[key];
      s.innerHTML = '<i data-mbok style="display:none"></i>' + ratingHTML(m.a, m.n);
      s.style.display = "inline-flex";
      s.style.alignItems = "center";
      s.removeAttribute("hidden");
      filled++;
    });
    return filled;
  }

  // ripeti finché i card del tema sono comparsi (defer può precederli) + osserva il DOM
  [0, 200, 500, 1000, 2000, 3500].forEach(function (t) { setTimeout(run, t); });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
  if (window.MutationObserver) {
    var stop = false;
    var obs = new MutationObserver(function () { if (!stop) run(); });
    try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) { }
    setTimeout(function () { stop = true; obs.disconnect(); }, 8000);
  }
})();
